// extracted by mini-css-extract-plugin
export default {"main":"DataSources_main__lKxan","wrapper":"DataSources_wrapper__VjZhY"};